// removed by extract-text-webpack-plugin
module.exports = {"brand":"#2f75c1","koala":"#c5c7cb","thunder":"#6b6e72","spacing-medium":"8px","this":"Tokenizer__this___1k-Bf","focused":"Tokenizer__focused___3YVfo","prompt":"Tokenizer__prompt___2YHno","inputContainer":"Tokenizer__inputContainer___CnKpt","inputHasValue":"Tokenizer__inputHasValue___1U8GT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/Tokenizer.css
// module id = 1729
// module chunks = 4